import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';
import ProgressOverlay from '../ProgressOverlay';

export default class FlagDropDown extends React.PureComponent {

    static propTypes = {
        options: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
        isPending: PropTypes.bool,
    }

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            selectedValue: '',
        };

        this.mouseLeaveTimeout = undefined;
        this.containerElement = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.onClickOutsideContainer);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.onClickOutsideContainer);
    }

    onClickOutsideContainer = (event) => {
        if (this.containerElement && !this.containerElement.current.contains(event.target)) {
            clearTimeout(this.mouseLeaveTimeout);
            this.setState({ expanded: false });
        }
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
            expanded: !prevState.expanded,
        }));
    };

    render() {
        const { expanded } = this.state;
        const numberOfOptionsSelected = this.props.options.filter(option => option.checked).length;

        return (
            <form className="form-common"
                ref={this.containerElemnent}
                onMouseLeave={() => {
                    this.mouseLeaveTimeout = setTimeout(() => {
                        this.setState({ expanded: false })
                    }, 900);
                }}
                onMouseEnter={() => { clearTimeout(this.mouseLeaveTimeout) }}
            >
                <div className={`flag-dropdown${expanded ? " expanded": ""}`} ref={this.containerElement}>
                    <div className="flag-select-box">
                        <div className="input-container">
                            <input
                                className="flag-input"
                                type="text"
                                readOnly
                                placeholder={this.state.expanded ? strings.formatString(strings.event__number_of_flag_selected_label, numberOfOptionsSelected) : strings.event_edit_flag_label}
                                onClick={this.toggleDropdown}
                            />
                            <i className="material-icons">keyboard_arrow_down</i>
                            </div>
                    </div>
                    {expanded && (
                        <div className="flag-checkboxes">
                            {this.props.options.map((option, index) => (
                                <label htmlFor={option.value} key={index}>
                                    <input
                                        type="checkbox"
                                        id={option.value}
                                        checked={option.checked}
                                        onChange={(e) => this.props.onChange(e, option.value)}
                                        disabled={this.props.loadingFlag === option.value}
                                    />
                                    {option.label}
                                </label>
                            ))}
                            {this.props.isPending ? <ProgressOverlay /> : null}
                        </div>
                    )}
                </div>
            </form>
        );
    }
}